function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { Fragment, useContext, useState, useEffect, forwardRef } from 'react';
import cn from 'classnames';
import { string, oneOfType, number, func, arrayOf, shape } from 'prop-types';
import { paramCase } from 'param-case';
import ScrollableContainer from '../../atoms/ScrollableContainer';
import { useRefs } from '../../hooks';
import FormContext from '../../context/FormContext';
import FormGroupContext from '../../context/FormGroupContext';
/**
 * FormRadioTabs component.
 */

var FormRadioTabs = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
      defaultValue = _ref.defaultValue,
      legend = _ref.legend,
      name = _ref.name,
      onChange = _ref.onChange,
      options = _ref.options,
      srOnlyLegend = _ref.srOnlyLegend,
      value = _ref.value;

  var _useContext = useContext(FormGroupContext),
      inputId = _useContext.inputId,
      feedbackId = _useContext.feedbackId;

  var _useContext2 = useContext(FormContext),
      inverted = _useContext2.inverted,
      onFormChange = _useContext2.onChange,
      defaultValues = _useContext2.defaultValues;

  var inputRefs = useRefs(options || []);

  var _useState = useState(value || defaultValue || (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues[name])),
      _useState2 = _slicedToArray(_useState, 2),
      currentValue = _useState2[0],
      setCurrentValue = _useState2[1];

  var activeOption = options === null || options === void 0 ? void 0 : options.find(function (option) {
    return option.value === currentValue;
  });
  useEffect(function () {
    if (value && value !== currentValue) {
      setCurrentValue(value);
    }
  }, [value]);
  /**
   * Handle a radio button being clicked.
   */

  var handleChange = function handleChange(evt) {
    setCurrentValue(evt.target.value);

    if (onChange) {
      onChange(evt);
    }

    if (onFormChange) {
      onFormChange(evt);
    }
  };
  /**
   * Get the React ref for an option.
   */


  var getInputRef = function getInputRef(checkedOption) {
    var optionIndex = options.findIndex(function (option) {
      return option === checkedOption;
    });
    return inputRefs[optionIndex];
  };
  /**
   * Select the first option in a group.
   */


  var selectFirstOptionInGroup = function selectFirstOptionInGroup(optionGroup) {
    var option = options.find(function (_ref2) {
      var group = _ref2.group;
      return group === optionGroup;
    });
    setCurrentValue(option.value);
    getInputRef(option).current.click();
  };
  /**
   * Check if an option is active.
   */


  var isOptionActive = function isOptionActive(option) {
    return option.value === currentValue;
  };
  /**
   * Get a DOM ID for an element.
   */


  var getDomId = function getDomId(suffix) {
    return paramCase([inputId, suffix].filter(function (x) {
      return x;
    }).join('-'));
  };

  return /*#__PURE__*/React.createElement("fieldset", {
    className: cn('form-radio-tabs', className, (activeOption === null || activeOption === void 0 ? void 0 : activeOption.group) && 'form-radio-tabs--has-active-group', inverted && 'form-radio-tabs--inverted'),
    ref: ref
  }, (legend || srOnlyLegend) && /*#__PURE__*/React.createElement("legend", {
    className: 'form-radio-tabs__legend body-copy mb-xs' + (srOnlyLegend ? " sr-only" : "")
  }, legend || srOnlyLegend), /*#__PURE__*/React.createElement(ScrollableContainer, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, options === null || options === void 0 ? void 0 : options.map(function (option, i) {
    var previousOptions = options.slice(0, i);
    var id = getDomId(option.group || option.value);
    var isActiveGroup = option.group === (activeOption === null || activeOption === void 0 ? void 0 : activeOption.group);
    var optionsInGroup = options.filter(function (_ref3) {
      var group = _ref3.group;
      return group === option.group;
    }); // Only add the first option of each group to the top-level tabs.

    var hadGroup = option.group && previousOptions.find(function (_ref4) {
      var group = _ref4.group;
      return group === option.group;
    });

    if (hadGroup) {
      return null;
    }

    return /*#__PURE__*/React.createElement(Fragment, {
      key: id
    }, /*#__PURE__*/React.createElement("div", {
      className: "form-radio-tabs__tab"
    }, option.group ? /*#__PURE__*/React.createElement("button", {
      className: 'form-radio-tabs__tab-label' + ((activeOption === null || activeOption === void 0 ? void 0 : activeOption.group) === option.group ? " form-radio-tabs__tab-label--active" : ""),
      type: "button",
      tabIndex: "-1",
      onClick: function onClick() {
        selectFirstOptionInGroup(option.group);
      }
    }, option.group) : /*#__PURE__*/React.createElement("label", {
      className: "form-radio-tabs__tab-label mb-reset d-flex justify-content-center" + (isOptionActive(option) ? " form-radio-tabs__tab-label--active" : ""),
      htmlFor: id
    }, option.label, /*#__PURE__*/React.createElement("input", {
      className: "sr-only",
      type: "radio",
      id: id,
      value: option.value,
      name: name,
      checked: isOptionActive(option),
      onChange: handleChange,
      ref: getInputRef(option),
      "aria-describedby": feedbackId
    }))), option.group && /*#__PURE__*/React.createElement(ScrollableContainer, {
      className: "form-radio-tabs__group p-absolute d-flex " + (isActiveGroup ? 'form-radio-tabs__group--active' : 'sr-only')
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex"
    }, optionsInGroup.map(function (groupedOption) {
      var groupedOptionInputId = getDomId(groupedOption.value);
      return /*#__PURE__*/React.createElement("label", {
        className: "form-radio-tabs__grouped-radio-button-label mr-md mb-reset",
        htmlFor: groupedOptionInputId,
        key: groupedOptionInputId
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        className: "form-radio-tabs__grouped-radio-button-input mr-xxs mb-reset",
        id: groupedOptionInputId,
        value: groupedOption.value,
        name: name,
        checked: isOptionActive(groupedOption),
        onChange: handleChange,
        ref: getInputRef(groupedOption),
        "aria-describedby": feedbackId
      }), groupedOption.label);
    }))));
  }))));
});
FormRadioTabs.displayName = 'FormRadioTabs';
FormRadioTabs.defaultProps = {
  className: null,
  defaultValue: null,
  legend: null,
  name: null,
  onChange: null,
  options: [],
  srOnlyLegend: null,
  value: null
};
FormRadioTabs.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Additional class names to add to the component root. */
  className: string,

  /** The default value for the input field. */
  defaultValue: string,

  /** A legend to show above the buttons. */
  legend: string,

  /** The input name. */
  name: oneOfType([number, string]),

  /** On change event handler. */
  onChange: func,

  /** The radio button options. */
  options: arrayOf(shape({
    group: string,
    label: string,
    value: string
  })),

  /** Add a legend for screen readers only. */
  srOnlyLegend: string,

  /** The value for the input field. */
  value: string
} : {};
export default FormRadioTabs;